"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerCompletenessFact = exports.propertyCompletenessFact = void 0;
const _1 = require(".");
const propertyCompletenessFact = (state, propertyId) => {
    const propertyFacts = state.data.facts.byPropertyByType[propertyId];
    return propertyFacts &&
        propertyFacts[_1.PROPERTY_COMPLETENESS_FACT] ? propertyFacts[_1.PROPERTY_COMPLETENESS_FACT] : null;
};
exports.propertyCompletenessFact = propertyCompletenessFact;
const customerCompletenessFact = (state, customerId) => {
    const customerFacts = state.data.facts.byAccountByType[customerId];
    return customerFacts &&
        customerFacts[_1.CUSTOMER_COMPLETENESS_FACT] ? customerFacts[_1.CUSTOMER_COMPLETENESS_FACT] : null;
};
exports.customerCompletenessFact = customerCompletenessFact;
//# sourceMappingURL=selectors.js.map